import { render, staticRenderFns } from "./FavoriteGameCategory.vue?vue&type=template&id=5d744c0a&"
import script from "./FavoriteGameCategory.vue?vue&type=script&lang=js&"
export * from "./FavoriteGameCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports